_N_E =
(window["webpackJsonp_N_E"] = window["webpackJsonp_N_E"] || []).push([[42],{

/***/ "1qWt":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export GoogleReCaptcha */
/* unused harmony export GoogleReCaptchaConsumer */
/* unused harmony export GoogleReCaptchaContext */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return l; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return y; });
/* unused harmony export withGoogleReCaptcha */
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__("q1tI");
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(react__WEBPACK_IMPORTED_MODULE_0__);

/*! *****************************************************************************
Copyright (c) Microsoft Corporation.

Permission to use, copy, modify, and/or distribute this software for any
purpose with or without fee is hereby granted.

THE SOFTWARE IS PROVIDED "AS IS" AND THE AUTHOR DISCLAIMS ALL WARRANTIES WITH
REGARD TO THIS SOFTWARE INCLUDING ALL IMPLIED WARRANTIES OF MERCHANTABILITY
AND FITNESS. IN NO EVENT SHALL THE AUTHOR BE LIABLE FOR ANY SPECIAL, DIRECT,
INDIRECT, OR CONSEQUENTIAL DAMAGES OR ANY DAMAGES WHATSOEVER RESULTING FROM
LOSS OF USE, DATA OR PROFITS, WHETHER IN AN ACTION OF CONTRACT, NEGLIGENCE OR
OTHER TORTIOUS ACTION, ARISING OUT OF OR IN CONNECTION WITH THE USE OR
PERFORMANCE OF THIS SOFTWARE.
***************************************************************************** */var c=function(e,t){return(c=Object.setPrototypeOf||{__proto__:[]}instanceof Array&&function(e,t){e.__proto__=t}||function(e,t){for(var r in t)t.hasOwnProperty(r)&&(e[r]=t[r])})(e,t)};var a,i=function(){return(i=Object.assign||function(e){for(var t,r=1,o=arguments.length;r<o;r++)for(var n in t=arguments[r])Object.prototype.hasOwnProperty.call(t,n)&&(e[n]=t[n]);return e}).apply(this,arguments)};function s(e,t,r,o){return new(r||(r=Promise))((function(n,c){function a(e){try{s(o.next(e))}catch(e){c(e)}}function i(e){try{s(o.throw(e))}catch(e){c(e)}}function s(e){var t;e.done?n(e.value):(t=e.value,t instanceof r?t:new r((function(e){e(t)}))).then(a,i)}s((o=o.apply(e,t||[])).next())}))}function u(e,t){var r,o,n,c,a={label:0,sent:function(){if(1&n[0])throw n[1];return n[1]},trys:[],ops:[]};return c={next:i(0),throw:i(1),return:i(2)},"function"==typeof Symbol&&(c[Symbol.iterator]=function(){return this}),c;function i(c){return function(i){return function(c){if(r)throw new TypeError("Generator is already executing.");for(;a;)try{if(r=1,o&&(n=2&c[0]?o.return:c[0]?o.throw||((n=o.return)&&n.call(o),0):o.next)&&!(n=n.call(o,c[1])).done)return n;switch(o=0,n&&(c=[2&c[0],n.value]),c[0]){case 0:case 1:n=c;break;case 4:return a.label++,{value:c[1],done:!1};case 5:a.label++,o=c[1],c=[0];continue;case 7:c=a.ops.pop(),a.trys.pop();continue;default:if(!(n=a.trys,(n=n.length>0&&n[n.length-1])||6!==c[0]&&2!==c[0])){a=0;continue}if(3===c[0]&&(!n||c[1]>n[0]&&c[1]<n[3])){a.label=c[1];break}if(6===c[0]&&a.label<n[1]){a.label=n[1],n=c;break}if(n&&a.label<n[2]){a.label=n[2],a.ops.push(c);break}n[2]&&a.ops.pop(),a.trys.pop();continue}c=t.call(e,a)}catch(e){c=[6,e],o=0}finally{r=n=0}if(5&c[0])throw c[1];return{value:c[0]?c[1]:void 0,done:!0}}([c,i])}}}!function(e){e.SCRIPT_NOT_AVAILABLE="Recaptcha script is not available"}(a||(a={}));var p=Object(react__WEBPACK_IMPORTED_MODULE_0__["createContext"])({}),f=p.Consumer,l=function(e){function r(){var t=null!==e&&e.apply(this,arguments)||this;return t.scriptId="google-recaptcha-v3",t.resolver=void 0,t.rejecter=void 0,t.grecaptcha=new Promise((function(e,r){t.resolver=e,t.rejecter=r})),t.executeRecaptcha=function(e){return s(t,void 0,void 0,(function(){var t;return u(this,(function(r){return t=this.props.reCaptchaKey,[2,this.grecaptcha.then((function(r){return r.execute(t,{action:e})}))]}))}))},t.handleOnLoad=function(){window&&window.grecaptcha?window.grecaptcha.ready((function(){t.resolver(window.grecaptcha)})):console.warn(a.SCRIPT_NOT_AVAILABLE)},t.injectGoogleReCaptchaScript=function(){if(document.getElementById(t.scriptId))t.handleOnLoad();else{var e=t.generateGoogleReCaptchaScript();("body"===(t.props.scriptProps||{}).appendTo?document.body:document.getElementsByTagName("head")[0]).appendChild(e)}},t.generateGoogleReCaptchaScript=function(){var e=t.props,r=e.reCaptchaKey,o=e.language,n=e.scriptProps,c=void 0===n?{}:n,a=c.nonce,i=c.defer,s=c.async,u=document.createElement("script");return u.id=t.scriptId,u.src=t.googleRecaptchaSrc+"?render="+r+(o?"&hl="+o:""),a&&(u.nonce=a),u.defer=!!i,u.async=!!s,u.onload=t.handleOnLoad,u},t}return function(e,t){function r(){this.constructor=e}c(e,t),e.prototype=null===t?Object.create(t):(r.prototype=t.prototype,new r)}(r,e),Object.defineProperty(r.prototype,"googleRecaptchaSrc",{get:function(){return"https://www."+(this.props.useRecaptchaNet?"recaptcha.net":"google.com")+"/recaptcha/api.js"},enumerable:!1,configurable:!0}),Object.defineProperty(r.prototype,"googleReCaptchaContextValue",{get:function(){return{executeRecaptcha:this.executeRecaptcha}},enumerable:!1,configurable:!0}),r.prototype.componentDidMount=function(){this.props.reCaptchaKey?this.injectGoogleReCaptchaScript():console.warn("<GoogleReCaptchaProvider /> recaptcha key not provided")},r.prototype.componentDidUpdate=function(e){this.props.reCaptchaKey||console.warn("<GoogleReCaptchaProvider /> recaptcha key not provided"),!e.reCaptchaKey&&this.props.reCaptchaKey&&this.injectGoogleReCaptchaScript()},r.prototype.componentWillUnmount=function(){var e=document.querySelector(".grecaptcha-badge");e&&e.parentNode&&document.body.removeChild(e.parentNode);var t=document.querySelector("#"+this.scriptId);t&&t.remove()},r.prototype.render=function(){var e=this.props.children;return Object(react__WEBPACK_IMPORTED_MODULE_0__["createElement"])(p.Provider,{value:this.googleReCaptchaContextValue},e)},r}(react__WEBPACK_IMPORTED_MODULE_0__["Component"]),y=function(){return Object(react__WEBPACK_IMPORTED_MODULE_0__["useContext"])(p)},d=function(e){var t=e.action,r=e.onVerify,o=(e.runOnlyOnMount,y());return Object(react__WEBPACK_IMPORTED_MODULE_0__["useEffect"])((function(){var e=o.executeRecaptcha;s(void 0,void 0,void 0,(function(){var o;return u(this,(function(n){switch(n.label){case 0:return e?[4,e(t)]:(console.warn("Execute recaptcha function not defined"),[2]);case 1:return o=n.sent(),r?(r(o),[2]):(console.warn("Please define an onVerify function"),[2])}}))}))}),[t,r,o]),null};function m(e,t){return e(t={exports:{}},t.exports),t.exports
/** @license React v16.13.1
 * react-is.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */}var h="function"==typeof Symbol&&Symbol.for,b=h?Symbol.for("react.element"):60103,v=h?Symbol.for("react.portal"):60106,S=h?Symbol.for("react.fragment"):60107,g=h?Symbol.for("react.strict_mode"):60108,$=h?Symbol.for("react.profiler"):60114,w=h?Symbol.for("react.provider"):60109,C=h?Symbol.for("react.context"):60110,P=h?Symbol.for("react.async_mode"):60111,x=h?Symbol.for("react.concurrent_mode"):60111,O=h?Symbol.for("react.forward_ref"):60112,R=h?Symbol.for("react.suspense"):60113,M=h?Symbol.for("react.suspense_list"):60120,j=h?Symbol.for("react.memo"):60115,_=h?Symbol.for("react.lazy"):60116,E=h?Symbol.for("react.block"):60121,T=h?Symbol.for("react.fundamental"):60117,N=h?Symbol.for("react.responder"):60118,A=h?Symbol.for("react.scope"):60119;function F(e){if("object"==typeof e&&null!==e){var t=e.$$typeof;switch(t){case b:switch(e=e.type){case P:case x:case S:case $:case g:case R:return e;default:switch(e=e&&e.$$typeof){case C:case O:case _:case j:case w:return e;default:return t}}case v:return t}}}function I(e){return F(e)===x}var L={AsyncMode:P,ConcurrentMode:x,ContextConsumer:C,ContextProvider:w,Element:b,ForwardRef:O,Fragment:S,Lazy:_,Memo:j,Portal:v,Profiler:$,StrictMode:g,Suspense:R,isAsyncMode:function(e){return I(e)||F(e)===P},isConcurrentMode:I,isContextConsumer:function(e){return F(e)===C},isContextProvider:function(e){return F(e)===w},isElement:function(e){return"object"==typeof e&&null!==e&&e.$$typeof===b},isForwardRef:function(e){return F(e)===O},isFragment:function(e){return F(e)===S},isLazy:function(e){return F(e)===_},isMemo:function(e){return F(e)===j},isPortal:function(e){return F(e)===v},isProfiler:function(e){return F(e)===$},isStrictMode:function(e){return F(e)===g},isSuspense:function(e){return F(e)===R},isValidElementType:function(e){return"string"==typeof e||"function"==typeof e||e===S||e===x||e===$||e===g||e===R||e===M||"object"==typeof e&&null!==e&&(e.$$typeof===_||e.$$typeof===j||e.$$typeof===w||e.$$typeof===C||e.$$typeof===O||e.$$typeof===T||e.$$typeof===N||e.$$typeof===A||e.$$typeof===E)},typeOf:F},V=m((function(e,t){ false&&false})),G=(V.AsyncMode,V.ConcurrentMode,V.ContextConsumer,V.ContextProvider,V.Element,V.ForwardRef,V.Fragment,V.Lazy,V.Memo,V.Portal,V.Profiler,V.StrictMode,V.Suspense,V.isAsyncMode,V.isConcurrentMode,V.isContextConsumer,V.isContextProvider,V.isElement,V.isForwardRef,V.isFragment,V.isLazy,V.isMemo,V.isPortal,V.isProfiler,V.isStrictMode,V.isSuspense,V.isValidElementType,V.typeOf,m((function(e){ true?e.exports=L:undefined}))),k={childContextTypes:!0,contextType:!0,contextTypes:!0,defaultProps:!0,displayName:!0,getDefaultProps:!0,getDerivedStateFromError:!0,getDerivedStateFromProps:!0,mixins:!0,propTypes:!0,type:!0},z={name:!0,length:!0,prototype:!0,caller:!0,callee:!0,arguments:!0,arity:!0},D={$$typeof:!0,compare:!0,defaultProps:!0,displayName:!0,propTypes:!0,type:!0},K={};function B(e){return G.isMemo(e)?D:K[e.$$typeof]||k}K[G.ForwardRef]={$$typeof:!0,render:!0,defaultProps:!0,displayName:!0,propTypes:!0},K[G.Memo]=D;var U=Object.defineProperty,q=Object.getOwnPropertyNames,W=Object.getOwnPropertySymbols,H=Object.getOwnPropertyDescriptor,J=Object.getPrototypeOf,Q=Object.prototype;var X=function e(t,r,o){if("string"!=typeof r){if(Q){var n=J(r);n&&n!==Q&&e(t,n,o)}var c=q(r);W&&(c=c.concat(W(r)));for(var a=B(t),i=B(r),s=0;s<c.length;++s){var u=c[s];if(!(z[u]||o&&o[u]||i&&i[u]||a&&a[u])){var p=H(r,u);try{U(t,u,p)}catch(e){}}}}return t},Y=function(e){var r=function(r){return Object(react__WEBPACK_IMPORTED_MODULE_0__["createElement"])(f,null,(function(o){return Object(react__WEBPACK_IMPORTED_MODULE_0__["createElement"])(e,i({},r,{googleReCaptchaProps:o}))}))};return r.displayName="withGoogleReCaptcha("+(e.displayName||e.name||"Component")+")",X(r,e),r};
//# sourceMappingURL=react-google-recaptcha-v3.esm.js.map


/***/ }),

/***/ "85Gz":
/***/ (function(module, exports, __webpack_require__) {


    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/forgot-password",
      function () {
        return __webpack_require__("CmmS");
      }
    ]);
  

/***/ }),

/***/ "CmmS":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "__N_SSP", function() { return __N_SSP; });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__("nKUr");
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__("q1tI");
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(react__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var react_google_recaptcha_v3__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__("1qWt");
/* harmony import */ var _components_AuthPageLayout__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__("VCoD");
/* harmony import */ var _ForgotPasswordForm__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__("Z5Bc");
/* harmony import */ var _index_scss__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__("C0ww");
/* harmony import */ var _index_scss__WEBPACK_IMPORTED_MODULE_5___default = /*#__PURE__*/__webpack_require__.n(_index_scss__WEBPACK_IMPORTED_MODULE_5__);







function ForgotPassword(_ref) {
  var csrfToken = _ref.csrfToken,
      recaptchaSiteKey = _ref.recaptchaSiteKey;
  return /*#__PURE__*/Object(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__["jsx"])(react_google_recaptcha_v3__WEBPACK_IMPORTED_MODULE_2__[/* GoogleReCaptchaProvider */ "a"], {
    reCaptchaKey: recaptchaSiteKey,
    children: /*#__PURE__*/Object(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__["jsx"])(_components_AuthPageLayout__WEBPACK_IMPORTED_MODULE_3__[/* default */ "a"], {
      pageClass: "page_forgot-password",
      children: /*#__PURE__*/Object(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__["jsx"])(_ForgotPasswordForm__WEBPACK_IMPORTED_MODULE_4__["default"], {
        csrfToken: csrfToken
      })
    })
  });
}

var __N_SSP = true;
/* harmony default export */ __webpack_exports__["default"] = (/*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_1___default.a.memo(ForgotPassword));

/***/ }),

/***/ "Fl18":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__("nKUr");

// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__("q1tI");
var react_default = /*#__PURE__*/__webpack_require__.n(react);

// EXTERNAL MODULE: ./node_modules/next/link.js
var next_link = __webpack_require__("YFqc");
var link_default = /*#__PURE__*/__webpack_require__.n(next_link);

// EXTERNAL MODULE: ./node_modules/next-i18next/dist/commonjs/index.js
var commonjs = __webpack_require__("yLev");

// EXTERNAL MODULE: ./node_modules/react-bootstrap/esm/Container.js
var Container = __webpack_require__("7vrA");

// EXTERNAL MODULE: ./node_modules/@babel/runtime/helpers/esm/extends.js
var esm_extends = __webpack_require__("wx14");

// EXTERNAL MODULE: ./node_modules/@babel/runtime/helpers/esm/objectWithoutPropertiesLoose.js
var objectWithoutPropertiesLoose = __webpack_require__("zLVn");

// EXTERNAL MODULE: ./node_modules/prop-types/index.js
var prop_types = __webpack_require__("17x9");
var prop_types_default = /*#__PURE__*/__webpack_require__.n(prop_types);

// EXTERNAL MODULE: ./node_modules/react-bootstrap/esm/Dropdown.js + 6 modules
var Dropdown = __webpack_require__("97+O");

// EXTERNAL MODULE: ./node_modules/react-bootstrap/esm/DropdownToggle.js
var DropdownToggle = __webpack_require__("4OCD");

// EXTERNAL MODULE: ./node_modules/react-bootstrap/esm/DropdownMenu.js + 1 modules
var DropdownMenu = __webpack_require__("rSmC");

// CONCATENATED MODULE: ./node_modules/react-bootstrap/esm/DropdownButton.js







var propTypes = {
  /**
   * An html id attribute for the Toggle button, necessary for assistive technologies, such as screen readers.
   * @type {string|number}
   * @required
   */
  id: prop_types_default.a.any,

  /** An `href` passed to the Toggle component */
  href: prop_types_default.a.string,

  /** An `onClick` handler passed to the Toggle component */
  onClick: prop_types_default.a.func,

  /** The content of the non-toggle Button.  */
  title: prop_types_default.a.node.isRequired,

  /** Disables both Buttons  */
  disabled: prop_types_default.a.bool,

  /**
   * Aligns the dropdown menu responsively.
   *
   * _see [DropdownMenu](#dropdown-menu-props) for more details_
   *
   * @type {"left"|"right"|{ sm: "left"|"right" }|{ md: "left"|"right" }|{ lg: "left"|"right" }|{ xl: "left"|"right"} }
   */
  menuAlign: DropdownMenu["a" /* alignPropType */],

  /** An ARIA accessible role applied to the Menu component. When set to 'menu', The dropdown */
  menuRole: prop_types_default.a.string,

  /** Whether to render the dropdown menu in the DOM before the first time it is shown */
  renderMenuOnMount: prop_types_default.a.bool,

  /**
   *  Which event when fired outside the component will cause it to be closed.
   *
   * _see [DropdownMenu](#dropdown-menu-props) for more details_
   */
  rootCloseEvent: prop_types_default.a.string,

  /** @ignore */
  bsPrefix: prop_types_default.a.string,

  /** @ignore */
  variant: prop_types_default.a.string,

  /** @ignore */
  size: prop_types_default.a.string
};
/**
 * A convenience component for simple or general use dropdowns. Renders a `Button` toggle and all `children`
 * are passed directly to the default `Dropdown.Menu`.
 *
 * _All unknown props are passed through to the `Dropdown` component._ Only
 * the Button `variant`, `size` and `bsPrefix` props are passed to the toggle,
 * along with menu related props are passed to the `Dropdown.Menu`
 */

var DropdownButton = react_default.a.forwardRef(function (_ref, ref) {
  var title = _ref.title,
      children = _ref.children,
      bsPrefix = _ref.bsPrefix,
      rootCloseEvent = _ref.rootCloseEvent,
      variant = _ref.variant,
      size = _ref.size,
      menuAlign = _ref.menuAlign,
      menuRole = _ref.menuRole,
      renderMenuOnMount = _ref.renderMenuOnMount,
      disabled = _ref.disabled,
      href = _ref.href,
      id = _ref.id,
      props = Object(objectWithoutPropertiesLoose["a" /* default */])(_ref, ["title", "children", "bsPrefix", "rootCloseEvent", "variant", "size", "menuAlign", "menuRole", "renderMenuOnMount", "disabled", "href", "id"]);

  return /*#__PURE__*/react_default.a.createElement(Dropdown["a" /* default */], Object(esm_extends["a" /* default */])({
    ref: ref
  }, props), /*#__PURE__*/react_default.a.createElement(DropdownToggle["a" /* default */], {
    id: id,
    href: href,
    size: size,
    variant: variant,
    disabled: disabled,
    childBsPrefix: bsPrefix
  }, title), /*#__PURE__*/react_default.a.createElement(DropdownMenu["b" /* default */], {
    align: menuAlign,
    role: menuRole,
    renderOnMount: renderMenuOnMount,
    rootCloseEvent: rootCloseEvent
  }, children));
});
DropdownButton.displayName = 'DropdownButton';
DropdownButton.propTypes = propTypes;
/* harmony default export */ var esm_DropdownButton = (DropdownButton);
// EXTERNAL MODULE: ./node_modules/@fortawesome/react-fontawesome/index.es.js
var index_es = __webpack_require__("IP2g");

// EXTERNAL MODULE: ./node_modules/@fortawesome/fontawesome-svg-core/index.es.js
var fontawesome_svg_core_index_es = __webpack_require__("7O5W");

// EXTERNAL MODULE: ./node_modules/@fortawesome/pro-solid-svg-icons/index.es.js
var pro_solid_svg_icons_index_es = __webpack_require__("4Bjl");

// EXTERNAL MODULE: ./share/language.js
var share_language = __webpack_require__("1kOT");

// EXTERNAL MODULE: ./share/routes.js
var routes = __webpack_require__("85xM");

// EXTERNAL MODULE: ./i18n.js
var i18n = __webpack_require__("k7Sn");

// EXTERNAL MODULE: ./components/Footer/footer.scss
var footer = __webpack_require__("mLyT");

// CONCATENATED MODULE: ./components/Footer/index.js













fontawesome_svg_core_index_es["b" /* library */].add(pro_solid_svg_icons_index_es["g" /* faHeart */]);

var Footer_LangItem = function LangItem(_ref) {
  var locale = _ref.locale,
      t = _ref.t;
  return /*#__PURE__*/Object(jsx_runtime["jsx"])("li", {
    children: /*#__PURE__*/Object(jsx_runtime["jsx"])("a", {
      className: "set-language",
      "data-lang": locale,
      href: "?locale=".concat(locale),
      children: t(locale)
    })
  });
};

function Footer(_ref2) {
  var t = _ref2.t;

  var _useContext = Object(react["useContext"])(commonjs["I18nContext"]),
      language = _useContext.i18n.language;

  return /*#__PURE__*/Object(jsx_runtime["jsx"])("footer", {
    children: /*#__PURE__*/Object(jsx_runtime["jsxs"])(Container["a" /* default */], {
      children: [/*#__PURE__*/Object(jsx_runtime["jsxs"])("div", {
        className: "footer-wrapper",
        children: [/*#__PURE__*/Object(jsx_runtime["jsxs"])("p", {
          children: ["Designed with \xA0", /*#__PURE__*/Object(jsx_runtime["jsx"])(index_es["a" /* FontAwesomeIcon */], {
            icon: "heart"
          }), "\xA0 in Taiwan"]
        }), /*#__PURE__*/Object(jsx_runtime["jsx"])("p", {
          className: "copyright",
          children: "\xA9 2020 CakeResume"
        })]
      }), /*#__PURE__*/Object(jsx_runtime["jsxs"])("div", {
        className: "footer-wrapper",
        children: [/*#__PURE__*/Object(jsx_runtime["jsxs"])("div", {
          className: "footer-link-wrapper",
          children: [/*#__PURE__*/Object(jsx_runtime["jsx"])(link_default.a, {
            href: routes["j" /* PRIVACY_POLICY_ROUTE_PATH */],
            children: /*#__PURE__*/Object(jsx_runtime["jsx"])("a", {
              className: "footer-link",
              target: "_blank",
              children: t('privacy')
            })
          }), /*#__PURE__*/Object(jsx_runtime["jsx"])(link_default.a, {
            href: routes["l" /* TERMS_OF_SERVICE_ROUTE_PATH */],
            children: /*#__PURE__*/Object(jsx_runtime["jsx"])("a", {
              className: "footer-link",
              target: "_blank",
              children: t('termsOfService')
            })
          })]
        }), /*#__PURE__*/Object(jsx_runtime["jsxs"])("div", {
          className: "footer-language-selector",
          children: [/*#__PURE__*/Object(jsx_runtime["jsx"])("span", {
            className: "language",
            children: t('language')
          }), /*#__PURE__*/Object(jsx_runtime["jsx"])(esm_DropdownButton, {
            drop: "up",
            alignRight: true,
            variant: "default",
            title: t(language),
            className: "btn-group",
            id: "language-dropdown",
            children: share_language["a" /* LANGUAGES */].map(function (l) {
              return /*#__PURE__*/Object(jsx_runtime["jsx"])(Footer_LangItem, {
                locale: l,
                t: t
              }, l);
            })
          })]
        })]
      })]
    })
  });
}

/* harmony default export */ var components_Footer = __webpack_exports__["a"] = (Object(i18n["withTranslation"])('common')(Footer));

/***/ }),

/***/ "HaE+":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return _asyncToGenerator; });
function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) {
  try {
    var info = gen[key](arg);
    var value = info.value;
  } catch (error) {
    reject(error);
    return;
  }

  if (info.done) {
    resolve(value);
  } else {
    Promise.resolve(value).then(_next, _throw);
  }
}

function _asyncToGenerator(fn) {
  return function () {
    var self = this,
        args = arguments;
    return new Promise(function (resolve, reject) {
      var gen = fn.apply(self, args);

      function _next(value) {
        asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value);
      }

      function _throw(err) {
        asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err);
      }

      _next(undefined);
    });
  };
}

/***/ }),

/***/ "LbSa":
/***/ (function(module, exports, __webpack_require__) {

/* eslint-disable */
var React = __webpack_require__("q1tI");
var SpriteSymbol = __webpack_require__("4BeY");
var sprite = __webpack_require__("IaFt");

var symbol = new SpriteSymbol({
  "id": "slick_logo-b227c1bd--sprite",
  "use": "slick_logo-b227c1bd--sprite-usage",
  "viewBox": "0 0 82 34",
  "content": "<symbol fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 82 34\" id=\"slick_logo-b227c1bd--sprite\"><g clip-path=\"url(#slick_logo-b227c1bd--sprite_clip0)\" fill=\"#434F4A\"><path d=\"M18.867 7.438l-3.732 2.217c-.697-1.214-1.362-2.006-1.994-2.376-.658-.422-1.507-.634-2.547-.634-1.277 0-2.337.364-3.18 1.09-.842.712-1.263 1.61-1.263 2.693 0 1.491 1.106 2.693 3.317 3.604l3.041 1.247c2.475 1.003 4.285 2.231 5.43 3.683 1.145 1.44 1.718 3.208 1.718 5.307 0 2.812-.935 5.136-2.804 6.97-1.882 1.849-4.219 2.773-7.01 2.773-2.645 0-4.83-.786-6.555-2.357C1.59 30.085.531 27.873.11 25.022l4.66-1.03c.21 1.795.58 3.036 1.106 3.723.948 1.32 2.33 1.98 4.146 1.98 1.435 0 2.626-.482 3.574-1.446.948-.963 1.422-2.184 1.422-3.663 0-.594-.086-1.135-.257-1.624a3.813 3.813 0 00-.77-1.366c-.342-.422-.79-.812-1.343-1.168-.553-.37-1.21-.72-1.974-1.05L7.73 18.15c-4.173-1.768-6.26-4.356-6.26-7.762 0-2.297.876-4.218 2.627-5.762 1.75-1.558 3.929-2.337 6.535-2.337 3.515 0 6.26 1.716 8.234 5.149zM28.799.012v33.445h-4.443V.012h4.443zM38.868 14.17v19.287h-4.442V14.17h4.442zm-5.114-8.02c0-.779.283-1.452.85-2.02a2.77 2.77 0 012.033-.851c.803 0 1.487.284 2.053.852.567.554.85 1.234.85 2.04a2.81 2.81 0 01-.85 2.059c-.552.567-1.23.851-2.033.851a2.793 2.793 0 01-2.054-.851c-.566-.568-.849-1.261-.849-2.08zm25.708 8.852v5.92c-1.013-1.24-1.922-2.092-2.725-2.554-.79-.475-1.717-.713-2.784-.713-1.671 0-3.06.588-4.166 1.763-1.105 1.175-1.658 2.646-1.658 4.416 0 1.808.533 3.293 1.6 4.455 1.078 1.162 2.454 1.742 4.126 1.742 1.066 0 2.007-.23 2.823-.692.79-.45 1.718-1.32 2.784-2.614v5.88c-1.803.938-3.607 1.407-5.41 1.407-2.975 0-5.463-.964-7.463-2.891-2.001-1.941-3.002-4.35-3.002-7.228s1.014-5.307 3.041-7.287c2.027-1.98 4.515-2.97 7.464-2.97 1.895 0 3.685.455 5.37 1.366zM69.275.012v20.396l6.26-6.238h5.962l-8.352 8.1 8.965 11.187h-5.766l-6.358-8.138-.71.713v7.425h-4.443V.012h4.442z\" /></g><defs><clipPath id=\"slick_logo-b227c1bd--sprite_clip0\"><path fill=\"#fff\" d=\"M0 0h82v34H0z\" /></clipPath></defs></symbol>"
});
sprite.add(symbol);

var SvgSpriteIcon = function SvgSpriteIcon(props) {
  return React.createElement(
    'svg',
    Object.assign({
      viewBox: symbol.viewBox
    }, props),
    React.createElement(
      'use',
      {
        xlinkHref: '#' + symbol.id
      }
    )
  );
};

SvgSpriteIcon.viewBox = symbol.viewBox;
SvgSpriteIcon.id = symbol.id;
SvgSpriteIcon.content = symbol.content;
SvgSpriteIcon.url = symbol.url;
SvgSpriteIcon.toString = symbol.toString;

module.exports = SvgSpriteIcon;
module.exports.default = SvgSpriteIcon;


/***/ }),

/***/ "Ogzj":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__("nKUr");
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__("q1tI");
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(react__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var next_link__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__("YFqc");
/* harmony import */ var next_link__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(next_link__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var react_bootstrap__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__("7vrA");
/* harmony import */ var _share_routes__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__("85xM");
/* harmony import */ var _images_Landing_slick_logo_svg_sprite__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__("LbSa");
/* harmony import */ var _images_Landing_slick_logo_svg_sprite__WEBPACK_IMPORTED_MODULE_5___default = /*#__PURE__*/__webpack_require__.n(_images_Landing_slick_logo_svg_sprite__WEBPACK_IMPORTED_MODULE_5__);
/* harmony import */ var _header_scss__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__("V2I+");
/* harmony import */ var _header_scss__WEBPACK_IMPORTED_MODULE_6___default = /*#__PURE__*/__webpack_require__.n(_header_scss__WEBPACK_IMPORTED_MODULE_6__);







var Logo = /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_1___default.a.forwardRef(function (_ref, ref) {
  var onClick = _ref.onClick,
      href = _ref.href;
  return /*#__PURE__*/Object(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__["jsx"])("a", {
    href: href,
    onClick: onClick,
    ref: ref,
    children: /*#__PURE__*/Object(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__["jsx"])(_images_Landing_slick_logo_svg_sprite__WEBPACK_IMPORTED_MODULE_5___default.a, {
      width: "82",
      height: "34"
    })
  });
});

var Header = function Header() {
  return /*#__PURE__*/Object(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__["jsx"])("header", {
    children: /*#__PURE__*/Object(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__["jsx"])(react_bootstrap__WEBPACK_IMPORTED_MODULE_3__[/* default */ "a"], {
      children: /*#__PURE__*/Object(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__["jsx"])(next_link__WEBPACK_IMPORTED_MODULE_2___default.a, {
        href: _share_routes__WEBPACK_IMPORTED_MODULE_4__[/* LANDING_ROUTE_PATH */ "h"],
        passHref: true,
        children: /*#__PURE__*/Object(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__["jsx"])(Logo, {})
      })
    })
  });
};

/* harmony default export */ __webpack_exports__["a"] = (Header);

/***/ }),

/***/ "VCoD":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__("nKUr");
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__("q1tI");
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(react__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var classnames__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__("TSYQ");
/* harmony import */ var classnames__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(classnames__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var _components_Header__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__("Ogzj");
/* harmony import */ var _components_Footer__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__("Fl18");
/* harmony import */ var _index_scss__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__("FzvF");
/* harmony import */ var _index_scss__WEBPACK_IMPORTED_MODULE_5___default = /*#__PURE__*/__webpack_require__.n(_index_scss__WEBPACK_IMPORTED_MODULE_5__);









var AuthPageLayout = function AuthPageLayout(_ref) {
  var pageClass = _ref.pageClass,
      children = _ref.children;
  var className = classnames__WEBPACK_IMPORTED_MODULE_2___default()("auth-page-layout ".concat(pageClass));
  return /*#__PURE__*/Object(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__["jsxs"])(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__["Fragment"], {
    children: [/*#__PURE__*/Object(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__["jsx"])(_components_Header__WEBPACK_IMPORTED_MODULE_3__[/* default */ "a"], {}), /*#__PURE__*/Object(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__["jsx"])("div", {
      className: className,
      children: children
    }), /*#__PURE__*/Object(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__["jsx"])(_components_Footer__WEBPACK_IMPORTED_MODULE_4__[/* default */ "a"], {})]
  });
};

/* harmony default export */ __webpack_exports__["a"] = (/*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_1___default.a.memo(AuthPageLayout));

/***/ }),

/***/ "Z5Bc":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony import */ var _babel_runtime_regenerator__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__("o0o1");
/* harmony import */ var _babel_runtime_regenerator__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_regenerator__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var _babel_runtime_helpers_esm_defineProperty__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__("rePB");
/* harmony import */ var _babel_runtime_helpers_esm_asyncToGenerator__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__("HaE+");
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__("nKUr");
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__("q1tI");
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_4___default = /*#__PURE__*/__webpack_require__.n(react__WEBPACK_IMPORTED_MODULE_4__);
/* harmony import */ var next_link__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__("YFqc");
/* harmony import */ var next_link__WEBPACK_IMPORTED_MODULE_5___default = /*#__PURE__*/__webpack_require__.n(next_link__WEBPACK_IMPORTED_MODULE_5__);
/* harmony import */ var classnames__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__("TSYQ");
/* harmony import */ var classnames__WEBPACK_IMPORTED_MODULE_6___default = /*#__PURE__*/__webpack_require__.n(classnames__WEBPACK_IMPORTED_MODULE_6__);
/* harmony import */ var react_redux__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__("/MKj");
/* harmony import */ var redux__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__("ANjH");
/* harmony import */ var _reducers_actions_globalAlert__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__("dDby");
/* harmony import */ var react_bootstrap__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__("7vrA");
/* harmony import */ var react_bootstrap__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__("cWnB");
/* harmony import */ var react_google_recaptcha_v3__WEBPACK_IMPORTED_MODULE_12__ = __webpack_require__("1qWt");
/* harmony import */ var react_hook_form__WEBPACK_IMPORTED_MODULE_13__ = __webpack_require__("NKCw");
/* harmony import */ var _share_routes__WEBPACK_IMPORTED_MODULE_14__ = __webpack_require__("85xM");
/* harmony import */ var _fortawesome_react_fontawesome__WEBPACK_IMPORTED_MODULE_15__ = __webpack_require__("IP2g");
/* harmony import */ var _fortawesome_fontawesome_svg_core__WEBPACK_IMPORTED_MODULE_16__ = __webpack_require__("7O5W");
/* harmony import */ var _fortawesome_pro_light_svg_icons__WEBPACK_IMPORTED_MODULE_17__ = __webpack_require__("WE53");
/* harmony import */ var _i18n__WEBPACK_IMPORTED_MODULE_18__ = __webpack_require__("k7Sn");
/* harmony import */ var _i18n__WEBPACK_IMPORTED_MODULE_18___default = /*#__PURE__*/__webpack_require__.n(_i18n__WEBPACK_IMPORTED_MODULE_18__);






function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { Object(_babel_runtime_helpers_esm_defineProperty__WEBPACK_IMPORTED_MODULE_1__[/* default */ "a"])(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }















_fortawesome_fontawesome_svg_core__WEBPACK_IMPORTED_MODULE_16__[/* library */ "b"].add(_fortawesome_pro_light_svg_icons__WEBPACK_IMPORTED_MODULE_17__[/* faEnvelope */ "k"], _fortawesome_pro_light_svg_icons__WEBPACK_IMPORTED_MODULE_17__[/* faExclamationTriangle */ "l"]);

function ForgotPasswordForm(_ref) {
  var csrfToken = _ref.csrfToken,
      showGlobalAlert = _ref.showGlobalAlert,
      t = _ref.t;

  var _useState = Object(react__WEBPACK_IMPORTED_MODULE_4__["useState"])(false),
      sending = _useState[0],
      setSending = _useState[1];

  var _useState2 = Object(react__WEBPACK_IMPORTED_MODULE_4__["useState"])(false),
      isSendFailed = _useState2[0],
      setIsSendFailed = _useState2[1];

  var _useGoogleReCaptcha = Object(react_google_recaptcha_v3__WEBPACK_IMPORTED_MODULE_12__[/* useGoogleReCaptcha */ "b"])(),
      executeRecaptcha = _useGoogleReCaptcha.executeRecaptcha;

  var _useForm = Object(react_hook_form__WEBPACK_IMPORTED_MODULE_13__[/* useForm */ "a"])(),
      register = _useForm.register,
      errors = _useForm.errors,
      handleSubmit = _useForm.handleSubmit;

  var onSubmit = /*#__PURE__*/function () {
    var _ref2 = Object(_babel_runtime_helpers_esm_asyncToGenerator__WEBPACK_IMPORTED_MODULE_2__[/* default */ "a"])( /*#__PURE__*/_babel_runtime_regenerator__WEBPACK_IMPORTED_MODULE_0___default.a.mark(function _callee(data) {
      var token, dataWithToken, res;
      return _babel_runtime_regenerator__WEBPACK_IMPORTED_MODULE_0___default.a.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              if (sending) {
                _context.next = 11;
                break;
              }

              setSending(true);
              _context.next = 4;
              return executeRecaptcha('forgot_password');

            case 4:
              token = _context.sent;
              dataWithToken = _objectSpread(_objectSpread({}, data), {}, {
                token: token
              });
              _context.next = 8;
              return fetch('/api/forgotPassword', {
                body: JSON.stringify(dataWithToken),
                method: 'POST'
              });

            case 8:
              res = _context.sent;

              if (res.ok) {
                setIsSendFailed(false);
                showGlobalAlert({
                  message: t('forgotYourPasswordSuccessHint'),
                  type: 'success'
                });
              } else {
                setIsSendFailed(true);
              }

              setSending(false);

            case 11:
            case "end":
              return _context.stop();
          }
        }
      }, _callee);
    }));

    return function onSubmit(_x) {
      return _ref2.apply(this, arguments);
    };
  }();

  var inputClass = function inputClass(isError) {
    return classnames__WEBPACK_IMPORTED_MODULE_6___default()({
      'is-error': isError
    });
  };

  return /*#__PURE__*/Object(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__["jsxs"])(react_bootstrap__WEBPACK_IMPORTED_MODULE_10__[/* default */ "a"], {
    children: [/*#__PURE__*/Object(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__["jsx"])("h1", {
      children: t('forgotYourPassword')
    }), /*#__PURE__*/Object(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__["jsx"])("h5", {
      children: t('forgotYourPasswordDesc')
    }), /*#__PURE__*/Object(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__["jsxs"])("form", {
      onSubmit: handleSubmit(onSubmit),
      children: [isSendFailed && /*#__PURE__*/Object(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__["jsxs"])("div", {
        className: "error-block",
        children: [/*#__PURE__*/Object(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__["jsx"])(_fortawesome_react_fontawesome__WEBPACK_IMPORTED_MODULE_15__[/* FontAwesomeIcon */ "a"], {
          icon: ['fal', 'exclamation-triangle']
        }), /*#__PURE__*/Object(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__["jsx"])("p", {
          className: "error-msg",
          children: t('forgotPasswordErrorMsg')
        })]
      }), /*#__PURE__*/Object(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__["jsx"])("input", {
        ref: register,
        type: "hidden",
        name: "_csrf_token",
        value: csrfToken
      }), /*#__PURE__*/Object(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__["jsxs"])("div", {
        className: "text-input-wrapper has-icon",
        children: [/*#__PURE__*/Object(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__["jsx"])("div", {
          className: "icon",
          children: /*#__PURE__*/Object(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__["jsx"])(_fortawesome_react_fontawesome__WEBPACK_IMPORTED_MODULE_15__[/* FontAwesomeIcon */ "a"], {
            icon: ['fal', 'envelope']
          })
        }), /*#__PURE__*/Object(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__["jsx"])("input", {
          ref: register({
            required: true
          }),
          className: inputClass(!!(errors.registration && errors.registration.email)),
          type: "email",
          name: "registration[email]",
          placeholder: t('emailAddress')
        })]
      }), /*#__PURE__*/Object(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__["jsx"])(react_bootstrap__WEBPACK_IMPORTED_MODULE_11__[/* default */ "a"], {
        type: "submit",
        disabled: sending,
        variant: "primary",
        children: t('reset')
      }), /*#__PURE__*/Object(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__["jsxs"])("p", {
        children: [t('newToSlick'), "\xA0\xA0", /*#__PURE__*/Object(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__["jsx"])(next_link__WEBPACK_IMPORTED_MODULE_5___default.a, {
          href: _share_routes__WEBPACK_IMPORTED_MODULE_14__[/* SIGN_UP_ROUTE_PATH */ "k"],
          children: t('signUp')
        })]
      })]
    })]
  });
}

var mapDispatchToProps = function mapDispatchToProps(dispatch) {
  return {
    showGlobalAlert: Object(redux__WEBPACK_IMPORTED_MODULE_8__[/* bindActionCreators */ "b"])(_reducers_actions_globalAlert__WEBPACK_IMPORTED_MODULE_9__[/* showGlobalAlert */ "d"], dispatch)
  };
};

/* harmony default export */ __webpack_exports__["default"] = (Object(_i18n__WEBPACK_IMPORTED_MODULE_18__["withTranslation"])('registration')(Object(react_redux__WEBPACK_IMPORTED_MODULE_7__[/* connect */ "b"])(null, mapDispatchToProps)( /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_4___default.a.memo(ForgotPasswordForm))));

/***/ }),

/***/ "dDby":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return SHOW_GLOBAL_ALERT; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return HIDE_GLOBAL_ALERT; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return showGlobalAlert; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return hideGlobalAlert; });
var SHOW_GLOBAL_ALERT = 'globalAlert/SHOW_GLOBAL_ALERT';
var HIDE_GLOBAL_ALERT = 'globalAlert/HIDE_GLOBAL_ALERT';

function showGlobalAlert(alert) {
  return {
    type: SHOW_GLOBAL_ALERT,
    alert: alert
  };
}

function hideGlobalAlert() {
  return {
    type: HIDE_GLOBAL_ALERT
  };
}



/***/ }),

/***/ "rePB":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return _defineProperty; });
function _defineProperty(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }

  return obj;
}

/***/ })

},[["85Gz",0,1,6,8,2,3,5,7,9,12,10,13,4]]]);